import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'sm:heading-2xl-desk heading-2xl mt-5 sm:mt-6',
    numberBlock: 'mt-5 flex items-center justify-between',
    number: 'heading-m-regular',
    numberChange:
      'heading-m-regular text-tertiary hover:text-accent cursor-pointer transition-colors',
    helperText: 'heading-m mt-5',
    otpContainer: 'mt-6 sm:mt-5',
    requestSmsBlock: 'mt-6 flex flex-col items-center gap-2',
    requestSmsTimer: 'heading-s',
    requestSms:
      'heading-m-regular text-tertiary hover:text-accent cursor-pointer transition-colors disabled:pointer-events-none disabled:opacity-50',
    arrow: 'size-6 scale-x-[-1]',
    button: 'mt-10 w-full',
    support: 'heading-m mt-6',
    supportPhone: 'heading-m-regular'
  }
});
